import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  ProLogContactInfoClickMutation,
  ProLogContactInfoClickMutationVariables,
} from '@gql/graphql';

export const PRO_LOG_CONTACT_INFO_CLICK = graphql(`
  mutation ProLogContactInfoClick($proId: Int!) {
    logContactInfoClick(proId: $proId)
  }
`);

export const useLogContactInfoClick = () => {
  const [logContactInfoClick, { loading, error }] = useMutation<
    ProLogContactInfoClickMutation,
    ProLogContactInfoClickMutationVariables
  >(PRO_LOG_CONTACT_INFO_CLICK);

  return {
    logContactInfoClick,
    logContactInfoClickLoading: loading,
    logContactInfoClickError: error,
  };
};
